import * as React from 'react';
import { forwardRef } from 'react';
import { AppBar, UserMenu, MenuItemLink, useTranslate } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import SettingsIcon from '@material-ui/icons/Settings';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import Logo from './Logo';
import { useMediaQuery, Theme, CssBaseline } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    [theme.breakpoints.up("sm")]: {
        title: {
            flex: 1,
        }
    },
    title: {
        // flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    logo: {
        flex: 1
    },
    spacer: {
        flex: 1,
    },
}))

const ConfigurationMenu = forwardRef<any, any>((props, ref) => {
    const translate = useTranslate();
    return (
        <MenuItemLink
            ref={ref}
            to="/configuration"
            primaryText={translate('pos.configuration')}
            leftIcon={<SettingsIcon />}
            onClick={props.onClick}
            sidebarIsOpen
        />
    );
});

const CustomUserMenu = (props: any) => (
    <UserMenu {...props}>
        <ConfigurationMenu />
    </UserMenu>
);

const CustomAppBar = (props: any) => {
    const theme = useTheme()
    const classes = useStyles();
    const isSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );

    return (
        <AppBar
            {...props}
            elevation={1}
            userMenu={isSmall ? <></> : <CustomUserMenu />}
        // position="static"
        >
            <CssBaseline />
            <Typography
                variant="h6"
                color="inherit"
                className={classes.title}
                id="react-admin-title"
            />
            {!isSmall && <Logo fill={theme.palette.text.primary} />}
            <span className={classes.spacer} />
        </AppBar>
    );
};

export default CustomAppBar;
